module.exports = __webpack_public_path__ + "static/media/Download_center.25093413.svg";